module.exports = __webpack_public_path__ + "img/gzh.4d73ccfc.png";